import Plus from "../../../assets/plus.svg";
import DotsMenu from "../../../assets/dots_menu.svg";
import DeleteRedIcon from "../../../assets/delete_red.svg";
import EditIcon from "../../../assets/edit.svg";
import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { Dropdown, Modal as FlowbiteModal } from "flowbite-react";
import { ColleagueForSelector, ColleagueFull, ColleagueModel } from "../../../types/users";
import Temp from "../../../assets/profile.svg";
import { shortenText } from "../../../helpers/text";
import DocumentImg from "../../../assets/document.svg";
import ArrowDown from "../../../assets/arrow_down.svg";
import ArrowUp from "../../../assets/arrow_up.svg";
import { getFileName } from "../../../helpers/media";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { FileGroup, TravelClaimFileInList } from "../../../types/travelClaims";
import { tripsAPI } from "../../../api";
import Close from "../../../assets/close.svg";
import {
    addTravelClaimColleague,
    deleteTravelClaimColleague,
    deleteTravelClaimFile,
    updateTravelClaimColleague
} from "../../../services/travelClaims";
import { ColleagueModelProvider, useColleagueModel } from "../../../context/colleagues";
import { CheckBox, SelectDropdown, TextareaCount } from "./Inputs";
import { useColleaguesQuery } from "../../../hooks/useUsersQuery";
import { isValidPhoneNumber } from "libphonenumber-js";
import { formatColleaguePostBrand } from "../../../helpers/users";
import { addParticipant } from "../../../services/chats";
import { useChatAvailableParticipantsQuery } from "../../../hooks/useChatAvailableParticipantsQuery";
import { UploadingFileInfo, UploadingMediaStatus } from "../../../types/media";
import { useAlert } from "../../../context/alert";
import { ColleagueAttachment, ColleagueDocAttachment } from "../../attachment/Attachment";
import { Media } from "../../../types/media";
import AttachmentIcon from "../../../assets/attachment.svg";
import AttachmentLight from "../../../assets/attachment_light.svg";
import {ColleagueInfoPopup, ColleagueInfoPopupHandle} from "../../ColleagueInfoPopup";

interface ColleaguesAndOutstaff {
    claim_pk: string
    colleagues: Array<ColleagueFull>
    outstaff: Array<ColleagueFull>
}

interface UploadingFileProps {
    onClick?: () => void
    progress: number
    disabled?: boolean
    name: string
    status?: UploadingMediaStatus
}


interface ColleaguesAndOutstaffTabs extends ColleaguesAndOutstaff {
    setActive: (tab: string) => void
    tab: string
    claim_pk: string
}

interface ColleaguesAndOutstaffTable extends ColleaguesAndOutstaff {
    tab: string
}


export const ColleaguesTabs = ({ colleagues, outstaff, setActive, tab, claim_pk }: ColleaguesAndOutstaffTabs) => {
    const bgActive = 'bg-[#fcd700]';
    const bgInactive = 'bg-white';
    const [bgColleagues, setBgColleagues] = useState<string>(bgInactive);
    const [bgOutstaff, setBgOutstaff] = useState<string>(bgInactive);
    useEffect(() => {
        if (tab === 'colleagues') {
            setBgColleagues(bgActive)
            setBgOutstaff(bgInactive)
        }
        if (tab === 'outstaff') {
            setBgColleagues(bgInactive)
            setBgOutstaff(bgActive)
        }
    }, [tab]);

    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const openAddModal = () => setIsAddModalOpen(true);
    const closeAddModal = () => setIsAddModalOpen(false);

    return (
        <div className="flex flex-col justify-between align-top">
            {/*ADD COLLEAGUE*/}
            <ColleagueModelProvider>
                <AddModal claim_pk={claim_pk} isOpen={isAddModalOpen} onClose={closeAddModal} />
            </ColleagueModelProvider>
            <div className="flex flex-row w-full justify-between items-center py-4">
                <div>Сотрудники</div>
                <button
                    onClick={openAddModal}
                    className="
                    !bg-transparent
                    inline-flex
                    flex-col
                    items-end
                    justify-center
                    gap-0.5
                    py-3
                    relative bg-white
                    rounded-lg
                    overflow-hidden
                ">
                    <div className="inline-flex items-center gap-1 relative flex-[0_0_auto]">
                        <img alt="" src={Plus} className="!relative !w-6 !h-6" />
                        <div
                            className="
                            relative
                            w-fit
                            text-downloadbtdefault
                            font-manager-acrom-ph1-16-medium-acrom
                            font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)]
                            text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)]
                            tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)]
                            leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)]
                            whitespace-nowrap
                            [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]
                            "
                        >
                            Добавить сотрудника
                        </div>
                    </div>
                </button>
            </div>
            {/* TABS */}
            <div className="
                flex
                w-full
                items-start
                p-1
                relative
                shadow-shadow-card
                bg-white
                rounded-lg
                overflow-hidden
                "
            >
                <button
                    onClick={() => setActive('colleagues')}
                    className={"inline-flex w-[49%] items-center justify-center gap-2.5 px-5 py-2.5 relative flex-[0_0_auto]  rounded-lg " + bgColleagues}
                >
                    <div
                        className="relative w-fit font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] text-black text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] whitespace-nowrap [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                        Сотрудники
                    </div>
                    <div className="relative flex-[0_0_auto] w-5 h-5 bg-white rounded-[10px]">
                        <div
                            className="absolute w-2.5 top-px left-[5px] font-client-acrom-h1-14-medium-acrom font-[number:var(--client-acrom-h1-14-medium-acrom-font-weight)] text-black text-[length:var(--client-acrom-h1-14-medium-acrom-font-size)] text-center tracking-[var(--client-acrom-h1-14-medium-acrom-letter-spacing)] leading-[var(--client-acrom-h1-14-medium-acrom-line-height)] whitespace-nowrap [font-style:var(--client-acrom-h1-14-medium-acrom-font-style)]">
                            {colleagues ? colleagues.length : 0}
                        </div>
                    </div>
                </button>
                <button
                    onClick={() => setActive('outstaff')}
                    className={"inline-flex w-[49%] items-center justify-center gap-2.5 px-5 py-2.5 relative flex-[0_0_auto]  rounded-lg " + bgOutstaff}>
                    <div
                        className="relative w-fit font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] text-[#282828] text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] whitespace-nowrap [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                        Внештатные
                    </div>
                    <div className="relative flex-[0_0_auto] w-5 h-5 bg-[#f2f2f2] rounded-[10px]">
                        <div
                            className="
                            absolute
                            w-2.5 top-px left-[5px]
                            font-client-acrom-h1-14-medium-acrom
                            font-[number:var(--client-acrom-h1-14-medium-acrom-font-weight)]
                            text-[length:var(--client-acrom-h1-14-medium-acrom-font-size)]
                            text-center tracking-[var(--client-acrom-h1-14-medium-acrom-letter-spacing)]
                            leading-[var(--client-acrom-h1-14-medium-acrom-line-height)]
                            whitespace-nowrap
                            [font-style:var(--client-acrom-h1-14-medium-acrom-font-style)]
                            "
                        >
                            {outstaff && outstaff.length ?
                                <span className="text-red-500">{outstaff.length}</span>
                                : <span className="text-black">0</span>
                            }
                        </div>
                    </div>
                </button>
            </div>
        </div>
    );
}

interface ColleagueProps {
    colleague: ColleagueFull
    claim_pk: string
}

interface ContextMenuProps {
    item: string;
    openFilesModal: () => void
    openRemoveModal: () => void
}

interface ModalProps {
    claim_pk: string;
    isOpen: boolean;
    onClose: () => void;
    colleague: ColleagueFull
}

interface AddModalProps {
    claim_pk: string;
    isOpen: boolean;
    onClose: () => void;
}

interface AddParticipantModalProps {
    claim_pk: string;
    chat_pk: string;
    isOpen: boolean;
    onClose: () => void;
}

interface AttachmentsEditProps {
    colleague: ColleagueFull
    claim_pk: string
    block?: boolean
    handleRemove: (pk: string) => void
}

interface AttachmentsProps {
    file_objs?: TravelClaimFileInList[],
    needed?: boolean
    group: FileGroup
}

interface AttachmentEditProps extends AttachmentsProps {
    colleague: ColleagueFull
    disabled?: boolean
    getFile?: (id: string) => Media | undefined;
    handleRemove: (pk: string) => void
}

const UploadingAttachment = ({ progress, name, status, onClick, disabled }: UploadingFileProps) => {
    const bgColor = status === 'ERROR' ? 'bg-red-100 ' : 'bg-emerald-100 '
    return (
        <div
            className="
            w-full
            mb-1
            inline-flex items-center
            gap-2 pl-3 pr-2 py-2
            relative
            flex-[0_0_auto]
            rounded-lg
            border-solid
            border-[0.5px]
            border-[#949494]
            "
        >
            {/*Фон загрузки*/}
            <div
                /*Ширину фона добавлять только так, если с классами, то глючит */
                style={{
                    width: progress + '%'
                }}
                className={"absolute top-0 left-0 rounded-lg h-full " + bgColor}
            ></div>
            <div className="
                    w-full
                    min-h-9
                    flex justify-between
                    items-center gap-1
            ">
                <img alt="" src={DocumentImg} className="!relative flex-[0_0_auto] !w-6 !h-6" />
                <div className="inline-flex flex-col justify-center items-start relative w-full">
                    <div
                        className="
                            relative
                            font-manager-acrom-ph-14-medium-acrom
                            font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)]
                            text-black
                            text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)]
                            tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)]
                            leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)]
                            overflow-hidden
                            whitespace-pre-wrap
                            break-word-only-long
                            [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]">
                        {getFileName(name, 50)}
                    </div>
                    <div
                        className="relative w-fit text-[#949494]
                            text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)]
                            leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)]
                            whitespace-nowrap font-manager-acrom-ph-14-medium-acrom
                            font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)]
                            tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)]
                            [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]">
                        {status === 'ERROR' && "Ошибка"}
                        {status === 'UPLOADING' && "Загрузка..."}
                        {status === 'UPLOADED' && "Загружено"}
                        {status === 'READY_TO_UPLOAD' && "Готов к загрузке"}
                    </div>
                </div>
                {/*Очистить незагруженный файл*/}
                <button
                    disabled={disabled}
                    onClick={onClick}
                    className="z-10 ml-auto cursor-pointer !w-8 !h-8"
                >
                    <img
                        alt=""
                        src={Close}
                    />
                </button>
            </div>

        </div>
    );
}

const AttachmentEdit = ({ file_objs, colleague, handleRemove, group, disabled, getFile }: AttachmentEditProps) => {
    const queryClient = useQueryClient();
    const fileInputRef = useRef<HTMLInputElement>(null);

    const {
        model,
        updateModel,
        resetModel
    } = useColleagueModel();

    // Загрузка файла
    const handleFilesChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const filesList = e.target.files;

        if (filesList) {
            // Выбранные файлы
            const filesArray = Array.from(filesList);
            const newFiles: Array<UploadingFileInfo> = filesArray.map(e => ({
                name: e.name,
                progress: 0,
                status: 'READY_TO_UPLOAD',
                media: e,
                group: group,
                colleague: colleague.pk
            }));

            // Проверяем наличие таких же
            const uniqueUploadingFiles = newFiles.filter(
                file => !model.uploadingFiles.some(nf => nf.group === group && nf.name === file.name)
            );

            // Добавляем только уникальные к существующим
            const mergedFiles = model.uploadingFiles.concat(uniqueUploadingFiles)
            // Сохраняем в модели
            updateModel({
                uploadingFiles: mergedFiles
            })
        }
        // Очищаем инпут. Т.к. его содержимое не отображается, то не оставляем его с выбранным файлом.
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    const handleRemoveUploading = (name: string, group: string) => {
        updateModel({
            // Удаляем из списка файл той же группы и с тем же названием
            uploadingFiles: model.uploadingFiles.filter(
                e => !(e.group === group && e.name === name)
            )
        })
    }

    // Вставка из буфера обмена START
    const handlePaste = (event: React.ClipboardEvent<HTMLDivElement>) => {
        // Если отключено, то не вставляем из буфера
        if (disabled) {
            return
        }

        const items = event.clipboardData.items;
        const fileList: File[] = [];

        // Обрабатываем данные буфера
        for (let i = 0; i < items.length; i++) {
            if (items[i].kind === 'file') {
                // Если файл, то получаем данные
                const file = items[i].getAsFile();
                if (file) {
                    fileList.push(file);
                }
            }
        }
        //
        if (fileList.length > 0) {
            // console.log(fileList);
            // Адаптируем данные из буфера обмена в файлы
            const dataTransfer = new DataTransfer();
            fileList.forEach(file => dataTransfer.items.add(file));
            const filesArray = Array.from(dataTransfer.files);
            const newFiles: Array<UploadingFileInfo> = filesArray.map(e => ({
                name: e.name,
                progress: 0,
                status: 'READY_TO_UPLOAD',
                media: e,
                group: group,
                colleague: colleague.pk
            }));

            // Проверяем наличие таких же
            const uniqueUploadingFiles = newFiles.filter(
                file => !model.uploadingFiles.some(nf => nf.group === group && nf.name === file.name)
            );

            // Добавляем только уникальные к существующим
            const mergedFiles = model.uploadingFiles.concat(uniqueUploadingFiles)
            // Сохраняем в модели
            updateModel({
                uploadingFiles: mergedFiles
            })
        }
    };
    // Вставка из буфера обмена STOP

    // Существующий файл
    return (
        <>
            <div className="w-full flex flex-col" onPaste={handlePaste}>
                <div
                    className="mb-2 flex w-full flex-row justify-between items-center gap-5 relative flex-[0_0_auto]">
                    <div
                        className="flex w-full
                        justify-center
                        bg-[#f2f2f2]
                        items-center
                        gap-2.5
                        relative
                        flex-[0_0_auto] rounded-lg">
                        <label
                            htmlFor={"upload-file" + group}
                            className="
                            cursor-pointer
                            w-full flex
                            flex-row
                            text-[length:var(--manager-acrom-ph1-18-medium-acrom-font-size)]
                            leading-[var(--manager-acrom-ph1-18-medium-acrom-line-height)]
                            font-manager-acrom-ph1-18-medium-acrom
                            font-[600]
                            tracking-[var(--manager-acrom-ph1-18-medium-acrom-letter-spacing)]
                            [font-style:var(--manager-acrom-ph1-18-medium-acrom-font-style)]
                            "
                        >
                            <input
                                disabled={disabled}
                                value="Загрузить документ"
                                onChange={() => {
                                }}
                                type="text"
                                className={
                                    `
                                    pl-11
                                    w-full
                                    bg-transparent
                                    px-4 py-3
                                    relative
                                    ${disabled ? 'text-melon-light-grey-darker' : 'text-melon-grey-darker'}
                                    outline-none
                                `
                                }
                            />
                            <img
                                alt=""
                                src={disabled ? AttachmentLight : AttachmentIcon}
                                className="!absolute left-3 top-3 !w-6 !h-6"
                            />
                        </label>
                        <input
                            ref={fileInputRef}
                            disabled={disabled}
                            id={"upload-file" + group}
                            type="file"
                            multiple
                            onChange={handleFilesChange}
                            className="hidden"
                        >
                        </input>
                    </div>
                </div>
                {model.uploadingFiles.filter(e => e.group === group).map((e, index) => <UploadingAttachment
                    disabled={disabled}
                    key={index}
                    onClick={() => handleRemoveUploading(e.name, e.group)}
                    name={e.name}
                    progress={e.progress}
                    status={e.status}
                />)}
                {/*/!*ПРОГРЕСС ЗАГРУЗКИ ФАЙЛА*!/*/}
                {/*{fileInfo && <UploadingAttachment*/}
                {/*    name={fileInfo.name}*/}
                {/*    progress={fileInfo.progress}*/}
                {/*    onClick={handleRemoveFailed}*/}
                {/*    status={fileInfo.status}*/}
                {/*/>}*/}
            </div>
            {/*ЗАГРУЖЕННЫЕ НА СЕРВЕР ФАЙЛЫ*/}
            {file_objs &&
                <>
                    {file_objs.filter(e => !model.deletingFiles.includes(e.pk)).map((file_obj, index) => (
                        <ColleagueAttachment
                            key={index}
                            disabled={disabled}
                            getFile={() => { console.log('lll'); return undefined; }}
                            file_obj={file_obj}
                            handleRemove={() => handleRemove(file_obj.pk)}
                            handleDownload={() => { }}
                        />
                    ))}
                </>
            }
        </>)
}

const ColleagueAttachmentsEdit = ({ claim_pk, colleague, block, handleRemove }: AttachmentsEditProps) => {
    const {
        model,
        updateModel,
        resetModel
    } = useColleagueModel();

    const [tickets, setTickets] = useState<TravelClaimFileInList[]>([])
    const [ticketsCheckboxDisabled, setTicketsCheckboxDisabled] = useState(false)
    const [hotels, setHotels] = useState<TravelClaimFileInList[]>([])
    const [hotelCheckboxDisabled, setHotelCheckboxDisabled] = useState(false)
    const [others, setOthers] = useState<TravelClaimFileInList[]>([])
    const [otherCheckboxDisabled, setOtherCheckboxDisabled] = useState(false)

    // Заполнение модели изменяемых полей в заявке
    useEffect(() => {
        updateModel({
            tickets_need: colleague.tickets_need,
            hotel_need: colleague.hotel_need,
            other_documents_need: colleague.other_documents_need,
        })
    }, []);

    useEffect(() => {
        const tickets = colleague.files.filter(e => e.group === 'TICKETS' && !e.deleted_at);
        setTickets(tickets)
        setTicketsCheckboxDisabled(!!tickets.length)

        const hotels = colleague.files.filter(e => e.group === 'HOTEL' && !e.deleted_at);
        setHotels(hotels)
        setHotelCheckboxDisabled(!!hotels.length)

        const others = colleague.files.filter(e => e.group === 'OTHER_DOCUMENTS' && !e.deleted_at);
        setOthers(others)
        setOtherCheckboxDisabled(!!others.length)

    }, [colleague.files]);

    return (
        <div className="w-full h-full flex flex-col items-start gap-5 relative ">
            <div
                className="
                mt-1
                h-full
                w-full
                text-black
                relative
                text-[length:var(--manager-acrom-h3-20-medium-acrom-font-size)]
                leading-[var(--manager-acrom-h3-20-medium-acrom-line-height)]
                font-manager-acrom-h3-20-medium-acrom
                font-[number:var(--manager-acrom-h3-20-medium-acrom-font-weight)]
                tracking-[var(--manager-acrom-h3-20-medium-acrom-letter-spacing)]
                [font-style:var(--manager-acrom-h3-20-medium-acrom-font-style)]
                "
            >
                Документы
            </div>
            <div className="w-full h-76 flex flex-col items-start gap-5 relative overflow-y-auto">
                <div className="w-full inline-flex flex-col items-start gap-2.5 relative">
                    <div
                        className="
                        w-full inline-flex items-center justify-between
                        text-[#949494]
                        text-[length:var(--client-acrom-ph1-16-medium-acrom-font-size)]
                        leading-[var(--client-acrom-ph1-16-medium-acrom-line-height)] relative
                        font-client-acrom-ph1-16-medium-acrom
                        font-[number:var(--client-acrom-ph1-16-medium-acrom-font-weight)]
                        tracking-[var(--client-acrom-ph1-16-medium-acrom-letter-spacing)]
                        [font-style:var(--client-acrom-ph1-16-medium-acrom-font-style)]
                        "
                    >
                        Билеты
                        <div className="inline-flex items-center gap-2.5 relative ">
                            <CheckBox
                                disabled={block || ticketsCheckboxDisabled}
                                checked={!model.tickets_need}
                                onChange={e => updateModel({ 'tickets_need': !e })}
                            />
                            <div
                                className={`
                                    w-full 
                                    relative 
                                    ${block || ticketsCheckboxDisabled ? 'text-melon-grey' : 'text-black '}
                                    font-manager-acrom-ph1-16-medium-acrom 
                                    leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] 
                                    text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] 
                                    [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]
                                    font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] 
                                    tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] 
                            `}>
                                Не требуется
                            </div>
                        </div>
                    </div>

                    <AttachmentEdit
                        disabled={block || !model.tickets_need}
                        group={'TICKETS'}
                        colleague={colleague}
                        handleRemove={handleRemove}
                        file_objs={tickets}
                    />
                </div>
                <div className="w-full inline-flex flex-col items-start gap-2.5 relative">
                    <div
                        className="inline-flex items-center justify-between w-full text-[#949494] text-[length:var(--client-acrom-ph1-16-medium-acrom-font-size)] leading-[var(--client-acrom-ph1-16-medium-acrom-line-height)] relative font-client-acrom-ph1-16-medium-acrom font-[number:var(--client-acrom-ph1-16-medium-acrom-font-weight)] tracking-[var(--client-acrom-ph1-16-medium-acrom-letter-spacing)] [font-style:var(--client-acrom-ph1-16-medium-acrom-font-style)]">
                        Отель
                        <div className="inline-flex items-center gap-2.5 relative flex-[0_0_auto]">
                            <CheckBox
                                disabled={block || hotelCheckboxDisabled}
                                checked={!model.hotel_need}
                                onChange={e => updateModel({ 'hotel_need': !e })}
                            />
                            <div
                                className={`
                                    w-full 
                                    relative 
                                    ${block || hotelCheckboxDisabled ? 'text-melon-grey' : 'text-black '}
                                    font-manager-acrom-ph1-16-medium-acrom 
                                    leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] 
                                    text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] 
                                    [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]
                                    font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] 
                                    tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] 
                            `}>
                                Не требуется
                            </div>
                        </div>
                    </div>
                    <AttachmentEdit
                        disabled={block || !model.hotel_need}
                        group={'HOTEL'}
                        handleRemove={handleRemove}
                        colleague={colleague}
                        file_objs={hotels}
                    />
                </div>
                <div className="w-full inline-flex flex-col items-start gap-2.5 relative">
                    <div
                        className="inline-flex items-center justify-between w-full text-[#949494] text-[length:var(--client-acrom-ph1-16-medium-acrom-font-size)] leading-[var(--client-acrom-ph1-16-medium-acrom-line-height)] relative font-client-acrom-ph1-16-medium-acrom font-[number:var(--client-acrom-ph1-16-medium-acrom-font-weight)] tracking-[var(--client-acrom-ph1-16-medium-acrom-letter-spacing)] [font-style:var(--client-acrom-ph1-16-medium-acrom-font-style)]">
                        Другие документы
                        <div className="inline-flex items-center gap-2.5 relative flex-[0_0_auto]">
                            <CheckBox
                                disabled={block || otherCheckboxDisabled}
                                checked={!model.other_documents_need}
                                onChange={e => updateModel({ 'other_documents_need': !e })}
                            />
                            <div
                                className={`
                                    w-full 
                                    relative 
                                    ${block || otherCheckboxDisabled ? 'text-melon-grey' : 'text-black '}
                                    font-manager-acrom-ph1-16-medium-acrom 
                                    leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] 
                                    text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] 
                                    [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]
                                    font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] 
                                    tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] 
                            `}>
                                Не требуется
                            </div>
                        </div>
                    </div>
                    <AttachmentEdit
                        disabled={block || !model.other_documents_need}
                        group={'OTHER_DOCUMENTS'}
                        colleague={colleague}
                        handleRemove={handleRemove}
                        file_objs={others}
                    />
                </div>
            </div>
        </div>
    );
}

const AttachmentsList = ({ file_objs, needed }: AttachmentsProps) => {
    // Файлы в списке коллег на экране заявки
    const handleDownload = (file_obj: TravelClaimFileInList) => {
        const link = window.document.createElement('a');
        if (!file_obj) {
            return
        }
        link.href = file_obj.media_info.file;
        link.download = file_obj.media_info.original_name;
        // Открываем окно "Сохранить как"
        link.target = '_blank';
        window.document.body.appendChild(link);
        link.click();
        window.document.body.removeChild(link);
    };
    if (needed && !file_objs?.length) {
        return <div> Требуется </div>
    }
    if (!needed && !file_objs?.length) {
        return <div> Не требуется </div>
    }
    return (
        <div className="flex flex-col gap-1 h-full w-full py-1">
            {file_objs?.map((file_obj, index) => (
                <ColleagueDocAttachment
                    file_obj={file_obj}
                    handleRemove={() => {
                    }}
                    handleDownload={(file) => {
                        handleDownload(file)
                    }}
                />
            ))}
        </div>
    );
}

const ColleagueEditModal = ({ isOpen, onClose, colleague, claim_pk }: ModalProps) => {
    const [block, setBlock] = useState(false);
    const [cursorClass, setCursorClass] = useState(' ');
    const [buttonClass, setButtonClass] = useState('bg-[#fcd700] ');

    const { setError, setInfo } = useAlert();
    const queryClient = useQueryClient();
    // Модель и методы для изменений
    const {
        model,
        updateModel,
        resetModel
    } = useColleagueModel();

    // Обновление данных
    const { mutate: updateColleague, isPending } = useMutation({
        mutationFn: ({ pk, claim_pk, model }: {
            pk: string,
            claim_pk: string,
            model: ColleagueModel
        }) => updateTravelClaimColleague(claim_pk, pk, model),
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ["travelClaim"] })
        },
        onSettled: () => {
            // Заново обновляем состояние модели редактирования
            resetModel();
            onClose();
        }
    });

    // Запрос на удаление
    const deleteFile = useMutation({
        mutationFn: ({ pk, claim_pk }: {
            pk: string,
            claim_pk: string
        }) => deleteTravelClaimFile(pk, claim_pk),
    });

    const handleMarkToDelete = (pk: string) => {
        const uniqueSet = new Set(model.deletingFiles)
        uniqueSet.add(pk)
        updateModel({
            deletingFiles: Array.from(uniqueSet)
        })
    }

    const uploadFiles = async () => {
        setBlock(true); // Блокируем форму
        if (!model.uploadingFiles?.length) {
            // Если нет файлов, то выходим
            return Promise.resolve()
        }

        // Статус загрузки для файлов
        const uploadingProgressOnFiles = model.uploadingFiles.map(e => {
            e.status = 'UPLOADING'
            return e
        })
        updateModel({
            uploadingFiles: uploadingProgressOnFiles
        });


        const formData = new FormData();
        model.uploadingFiles.forEach((fileData, index) => {
            formData.append(`files[${index}][media]`, fileData.media);
            formData.append(`files[${index}][colleague]`, fileData.colleague);
            formData.append(`files[${index}][group]`, fileData.group);
        });

        await tripsAPI.post(
            `claim/${claim_pk}/files/batch_create/`,
            formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / (progressEvent.total || 1));
                console.log("Загрузка % " + percentCompleted);
                const uploadingProgressOnFiles = model.uploadingFiles.map(e => {
                    e.progress = percentCompleted
                    return e
                })
                updateModel({
                    uploadingFiles: uploadingProgressOnFiles
                });
            }
        }
        )
        // Инвалидация файлов после успешной загрузки
        queryClient.invalidateQueries({ queryKey: ["travelClaim"] });
        setInfo('Файлы загружены');
    }

    const removeFiles = async () => {
        setBlock(true); // Блокируем форму
        if (!model.deletingFiles?.length) {
            // Если нет файлов, то выходим
            return Promise.resolve()
        }

        // Запускаем параллельно запросы на удаление, ждём успех ото всех и закрываем, иначе не закрываем
        const promises = model.deletingFiles.map((fileId) => deleteFile.mutateAsync({
            pk: fileId,
            claim_pk: claim_pk
        }));
        await Promise.all(promises);

        setInfo('Файлы удалены');
    }

    const handleClose = () => {
        resetModel();
        onClose();
    }

    const handleSave = async () => {
        // Удаление файлов
        await removeFiles();
        try {
            // Загрузка файлов
            await uploadFiles();
            updateColleague({ pk: colleague.pk, claim_pk, model });
        } catch (error) {
            const uploadingProgressOnFiles = model.uploadingFiles.map(e => {
                e.status = 'ERROR';
                return e;
            })
            updateModel({
                uploadingFiles: uploadingProgressOnFiles
            });
        }
        setBlock(false);
    }

    useEffect(() => {
        if (block) {
            setCursorClass('cursor-progress ')
            setButtonClass('bg-[#f2f2f2] ')
        } else {
            setCursorClass(' ')
            setButtonClass('bg-[#fcd700] ')
        }
    }, [block]);


    // Модальное окно с редактированием файлов сотрудника
    return (
        <FlowbiteModal
            show={isOpen}
            size={'md'}
        >
            <div
                className={"w-full flex flex-col items-start gap-8 p-8 relative bg-white rounded-lg overflow-hidden " + cursorClass}>
                {/*CONTAINER*/}
                <div
                    className="w-full min-h-32 flex flex-col items-start gap-2 relative overflow-y-auto"
                >
                    {/*HEADER*/}
                    <div
                        className="
                            relative
                            w-full
                            flex flex-row justify-between items-center
                            text-black text-2xl
                            leading-[normal]
                            [font-family:'Acrom-Medium',Helvetica]
                            font-medium tracking-[0]
                        "
                    >
                        <div>
                            Редактировать
                        </div>
                        {/*CLOSE BUTTON*/}
                        <button
                            disabled={block}
                            onClick={handleClose}
                            className="flex justify-center items-center w-8 h-8 top-2.5 bg-[#f2f2f2] rounded-lg overflow-hidden">
                            <img src={Close} className=" w-6 h-6" alt="Manager ic close" />
                        </button>
                    </div>
                    {/*BODY*/}
                    <div
                        className="w-full h-full flex-col items-start gap-8 relative "
                    >
                        {/*COLLEAGUE*/}
                        <div className="w-full inline-flex flex-col items-start gap-5 relative ">
                            <div
                                className="
                                relative
                                w-full text-black
                                text-[length:var(--manager-acrom-h3-20-medium-acrom-font-size)]
                                leading-[var(--manager-acrom-h3-20-medium-acrom-line-height)]
                                font-manager-acrom-h3-20-medium-acrom
                                font-[number:var(--manager-acrom-h3-20-medium-acrom-font-weight)]
                                tracking-[var(--manager-acrom-h3-20-medium-acrom-letter-spacing)]
                                [font-style:var(--manager-acrom-h3-20-medium-acrom-font-style)]
                                "
                            >
                                Сотрудник
                            </div>
                            <div className="flex w-full justify-start items-center gap-3 ">
                                <img className="relative w-16 h-16 rounded-full"
                                    src={colleague.colleague_pk?.photo_img?.file ?? Temp}
                                    alt="" />
                                <div className="flex flex-col w-auto items-start gap-0.5 relative">
                                    <div
                                        className="
                                            relative
                                            w-full text-black
                                            font-manager-acrom-ph1-16-medium-acrom
                                            leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)]
                                            [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]
                                            text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)]
                                            font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)]
                                            tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)]
                                        "
                                    >
                                        {
                                            colleague.type === 'OUTSTAFF' ?
                                                shortenText(colleague.full_name, 64) :
                                                shortenText(
                                                    `${colleague.colleague_pk?.last_name} ${colleague.colleague_pk?.first_name} ${colleague.colleague_pk?.middle_name}`, 64
                                                )
                                        }
                                    </div>
                                    <div
                                        className="
                                        w-full
                                        text-[#949494]
                                        text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)]
                                        leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)]
                                        relative
                                        font-manager-acrom-ph-14-medium-acrom
                                        font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)]
                                        tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)]
                                        [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]
                                        "
                                    >
                                        {shortenText(formatColleaguePostBrand(colleague), 64)}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*DOCS*/}
                        <ColleagueAttachmentsEdit
                            block={block}
                            claim_pk={claim_pk}
                            handleRemove={handleMarkToDelete}
                            colleague={colleague}
                        />
                    </div>
                    {/*SAVE BUTTON*/}
                    <button
                        disabled={block}
                        onClick={handleSave}
                        className={"w-full inline-flex flex-col items-start gap-2.5 px-5 py-3.5 relative flex-[0_0_auto] rounded-lg overflow-hidden " + buttonClass + cursorClass}
                    >
                        <div
                            className="
                            w-full
                            flex items-center justify-center
                            font-manager-acrom-button4-16-medium-acrom
                            font-[number:var(--manager-acrom-button4-16-medium-acrom-font-weight)]
                            text-black
                            text-[length:var(--manager-acrom-button4-16-medium-acrom-font-size)]
                            text-center tracking-[var(--manager-acrom-button4-16-medium-acrom-letter-spacing)]
                            leading-[var(--manager-acrom-button4-16-medium-acrom-line-height)]
                            [font-style:var(--manager-acrom-button4-16-medium-acrom-font-style)]
                            "
                        >
                            Сохранить
                        </div>
                    </button>
                </div>
            </div>
        </FlowbiteModal>
    );
};

const RemoveModal = ({ isOpen, onClose, colleague, claim_pk }: ModalProps) => {
    // Модальное окно с редактированием файлов сотрудника

    const queryClient = useQueryClient();
    // Запрос на удаление
    const { mutate: deleteColleague, isPending } = useMutation({
        mutationFn: ({ pk, claim_pk }: {
            pk: string,
            claim_pk: string
        }) => deleteTravelClaimColleague(pk, claim_pk),
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ["travelClaim"] })
        }
    });

    const handleRemove = () => {
        deleteColleague({ pk: colleague.pk, claim_pk })
    }


    const displayedName = () => {
        return colleague.type === 'OUTSTAFF' ?
            shortenText(colleague.full_name, 64) :
            shortenText(
                `${colleague.colleague_pk?.last_name} ${colleague.colleague_pk?.first_name} ${colleague.colleague_pk?.middle_name}`, 64
            )
    }

    return (
        <FlowbiteModal
            show={isOpen}
            onClose={onClose}
            size={'md'}
        >
            <div
                className="w-full inline-flex flex-col items-start p-8 relative bg-white rounded-lg overflow-hidden">
                {/*CONTAINER*/}
                <div className="w-full inline-flex flex-col items-start relative flex-[0_0_auto]">
                    {/*HEADER*/}
                    <div
                        className="
                        relative
                        w-full flex flex-row justify-end items-center text-black text-2xl
                        leading-[normal]
                        [font-family:'Acrom-Medium',Helvetica] font-medium tracking-[0]
                        "
                    >
                        {/*CLOSE BUTTON*/}
                        <button
                            onClick={onClose}
                            className="flex justify-center items-center w-8 h-8 top-2.5 bg-[#f2f2f2] rounded-lg overflow-hidden">
                            <img src={Close} className=" w-6 h-6" alt="Manager ic close" />
                        </button>
                    </div>
                    {/*BODY*/}
                    <div className="w-full inline-flex flex-col items-start gap-8 relative flex-[0_0_auto]">
                        {/*COLLEAGUE*/}
                        <div
                            className="w-full inline-flex flex-col mb-4 mt-1 items-start gap-5 relative flex-[0_0_auto]">
                            <div className="flex w-full p-1 justify-start items-center gap-3 rounded-lg bg-gray-100">
                                <img className="relative w-16 h-16 rounded-full"
                                    src={colleague.colleague_pk?.photo_img?.file ?? Temp}
                                    alt="" />
                                <div className="flex flex-col w-auto items-start gap-0.5 relative">
                                    <div
                                        className="
                                        w-full
                                        text-black
                                        text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)]
                                        leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)]
                                        relative
                                        font-manager-acrom-ph1-16-medium-acrom
                                        font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)]
                                        tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)]
                                        [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]
                                        "
                                    >
                                        {displayedName()}
                                    </div>
                                    <div
                                        className="
                                        relative
                                        w-full
                                        text-[#949494]
                                        text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)]
                                        leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)]
                                        font-manager-acrom-ph-14-medium-acrom
                                        font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)]
                                        tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)]
                                        [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]
                                        "
                                    >
                                        {shortenText(formatColleaguePostBrand(colleague), 64)}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*TEXT*/}
                        <div className=" text-2xl text-center">
                            Вы точно хотите удалить сотрудника?
                        </div>
                    </div>
                    {/*BUTTONS*/}
                    <div className="w-full flex flex-col mt-5 gap-5 justify-center items-center">
                        <button
                            onClick={handleRemove}
                            className="
                            w-full inline-flex flex-col items-start gap-2.5 px-5 py-3.5
                            relative
                            flex-[0_0_auto]
                            bg-[#fcd700] rounded-lg overflow-hidden
                            ">
                            <div
                                className="
                                w-full
                                flex items-center justify-center
                                font-manager-acrom-button4-16-medium-acrom
                                font-[number:var(--manager-acrom-button4-16-medium-acrom-font-weight)]
                                text-black text-[length:var(--manager-acrom-button4-16-medium-acrom-font-size)]
                                text-center tracking-[var(--manager-acrom-button4-16-medium-acrom-letter-spacing)]
                                leading-[var(--manager-acrom-button4-16-medium-acrom-line-height)]
                                [font-style:var(--manager-acrom-button4-16-medium-acrom-font-style)]
                                "
                            >
                                Удалить
                            </div>
                        </button>
                        <button
                            onClick={onClose}
                            className="
                            w-full inline-flex flex-col
                            items-start gap-2.5 px-5 py-3.5 relative flex-[0_0_auto] bg-gray-100 rounded-lg overflow-hidden">
                            <div
                                className="
                                w-full
                                flex items-center justify-center
                                font-manager-acrom-button4-16-medium-acrom
                                font-[number:var(--manager-acrom-button4-16-medium-acrom-font-weight)]
                                text-black text-[length:var(--manager-acrom-button4-16-medium-acrom-font-size)]
                                text-center tracking-[var(--manager-acrom-button4-16-medium-acrom-letter-spacing)]
                                leading-[var(--manager-acrom-button4-16-medium-acrom-line-height)]
                                [font-style:var(--manager-acrom-button4-16-medium-acrom-font-style)]
                                "
                            >
                                Отмена
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </FlowbiteModal>
    );
};

interface ErrorsProps {
    full_name?: string | null
    phone?: string | null
    colleague_pk?: string | null
}

export const AddModal = ({ isOpen, onClose, claim_pk }: AddModalProps) => {
    // Модальное окно с заполнением данных о сотруднике и добавлением
    const queryClient = useQueryClient();

    // Модель и методы для изменений
    const {
        model,
        updateModel,
        resetModel
    } = useColleagueModel();

    // Запрос на удаление
    const { mutate: update, isPending } = useMutation({
        mutationFn: ({ claim_pk, model }: {
            claim_pk: string,
            model: ColleagueModel
        }) => addTravelClaimColleague(claim_pk, model),
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['travelClaim', claim_pk.toString()] })
        },
        onSettled: () => {
            // Заново обновляем состояние модели редактирования
            resetModel()
            onClose()
        }
    });

    // Заполнение модели изменяемых полей в заявке
    useEffect(() => {
        updateModel({
            'tickets_need': true,
            'hotel_need': true,
            'other_documents_need': true
        })
    }, []);


    // Устанавливаем список как константу для использования в типе
    const requiredFieldsColleague = [
        'colleague_pk',
    ] as const
    const requiredFieldsOutstaff = [
        'full_name',
        // 'phone',
    ] as const
    // Ошибки в полях
    const [fieldsErrors, setFieldsErrors] = useState<ErrorsProps>({})

    // Сохранение модели
    const handleSave = () => {
        // Данные по ошибкам
        let errors: ErrorsProps = {}

        // Валидация полей
        // if (model.type === 'OUTSTAFF' && !isValidPhoneNumber(model.phone || '', "RU")) {
        if (model.phone && !isValidPhoneNumber(model.phone || '', "RU")) {
            errors.phone = 'Некорректный номер телефона'
        }

        const requiredFields = model.type === 'COLLEAGUE' ? requiredFieldsColleague : requiredFieldsOutstaff;

        // Проверка обязательных полей
        requiredFields.map(e => {
            if (!model[e]) {
                errors[e] = 'Обязательное поле'
            }
        })

        //Установка текста ошибок в полях
        setFieldsErrors(errors)

        // Проверка результатов валидации полей
        if (Object.values(errors).some(e => !!e)) {
            // alert('Ошибки валидации');
        } else {
            update({ claim_pk, model });
        }
    }

    const handlePhoneChange = (value: string) => {
        setFieldsErrors(prevState => ({ ...prevState, phone: null }));
        updateModel({ 'phone': value })
    }
    const handleNameChange = (value: string) => {
        setFieldsErrors(prevState => ({ ...prevState, full_name: null }));
        updateModel({ 'full_name': value })
    }

    const handleColleagueChange = (value: ColleagueForSelector) => {
        setFieldsErrors(prevState => ({ ...prevState, colleague_pk: null }));
        updateModel({ 'colleague_pk': value })
    }

    const handleClose = () => {
        resetModel()
        setFieldsErrors({})
        onClose()
    }

    return (
        <FlowbiteModal
            show={isOpen}
            onClose={onClose}
            size={'md'}
        >
            <div className="w-full flex p-6 relative bg-white rounded-lg overflow-hidden">
                {/*CONTAINER*/}
                <div className="w-full inline-flex flex-col justify-between items-center">
                    {/*HEADER*/}
                    <div className="
                        w-full
                        mb-4
                        inline-flex flex-row
                        justify-end
                        items-center
                        text-black text-2xl leading-[normal]
                        relative [font-family:'Acrom-Medium',Helvetica]
                        font-medium
                        tracking-[0]
                    ">
                        {/*CLOSE BUTTON*/}
                        <button
                            onClick={onClose}
                            className="flex justify-center items-center w-8 h-8 top-2.5 bg-[#f2f2f2] rounded-lg overflow-hidden">
                            <img src={Close} className=" w-6 h-6" alt="Manager ic close" />
                        </button>
                    </div>
                    {/*BODY*/}
                    <div className="
                        w-full
                        max-h-[48rem]
                        inline-flex
                        flex-col
                        items-start
                        gap-4
                    ">
                        {/*ТИП*/}
                        <div
                            className="flex flex-row justify-between items-center rounded-lg bg-gray-300 mt-2 w-full p-5 mb-5">
                            {/*COLLEAGUE*/}
                            <div className="inline-flex items-center gap-2.5 relative flex-[0_0_auto]">
                                <CheckBox
                                    checked={model.type === 'COLLEAGUE'}
                                    onChange={
                                        () => {
                                            updateModel({ 'type': 'COLLEAGUE' })
                                            updateModel({ 'full_name': null })
                                            updateModel({ 'phone': null })
                                            updateModel({ 'colleague_pk': null })
                                        }
                                    } />
                                <div
                                    className="w-full text-black text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] relative font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                                    Коллега
                                </div>
                            </div>
                            {/*OUTSTAFF*/}
                            <div className="inline-flex items-center gap-2.5 relative flex-[0_0_auto]">
                                <CheckBox
                                    checked={model.type === 'OUTSTAFF'}
                                    onChange={(e) => {
                                        updateModel({ 'type': 'OUTSTAFF' })
                                        updateModel({ 'colleague_pk': null })
                                    }} />
                                <div
                                    className="w-full text-black text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] relative font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                                    Внештатный сотрудник
                                </div>
                            </div>
                        </div>
                        <div className="w-full h-full flex flex-col gap-4 overflow-y-auto">
                            {/*СПИСОК ПОЛЬЗОВАТЕЛЕЙ ДЛЯ КОЛЛЕГ*/}
                            {
                                model.type == 'COLLEAGUE' &&
                                <ColleagueSearch
                                    colleague_pk={model.colleague_pk}
                                    error={fieldsErrors?.colleague_pk || null}
                                    required={requiredFieldsColleague.includes('colleague_pk')}
                                    onChange={e => handleColleagueChange(e)}
                                />
                            }
                            {/*ДЛЯ ВНЕШТАТНЫХ СОТРУДНИКОВ*/}
                            {
                                model.type == 'OUTSTAFF' &&
                                <div className="w-full flex flex-col justify-between items-center">
                                    <NameEdit
                                        name={model.full_name}
                                        error={fieldsErrors?.full_name || null}
                                        required={requiredFieldsOutstaff.includes('full_name')}
                                        onChange={(e) => handleNameChange(e)} />
                                </div>
                            }

                            {/*БИЛЕТЫ*/}
                            <div className="inline-flex items-center gap-2.5 relative flex-[0_0_auto]">
                                <CheckBox
                                    checked={model.tickets_need}
                                    onChange={(e) => updateModel({ 'tickets_need': e })} />
                                <div
                                    className="w-full text-black text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] relative font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                                    Билеты
                                </div>
                            </div>
                            {/*ОТЕЛЬ*/}
                            <div className="inline-flex items-center gap-2.5 relative flex-[0_0_auto]">
                                <CheckBox
                                    checked={model.hotel_need}
                                    onChange={(e) => updateModel({ 'hotel_need': e })} />
                                <div
                                    className="w-full text-black text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] relative font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                                    Отель
                                </div>
                            </div>
                            {/*ДРУГИЕ ДОКУМЕНТЫ*/}
                            <div className="inline-flex items-center gap-2.5 relative flex-[0_0_auto]">
                                <CheckBox
                                    checked={model.other_documents_need}
                                    onChange={(e) => updateModel({ 'other_documents_need': e })} />
                                <div
                                    className="w-full text-black text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] relative font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                                    Другие документы
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*BUTTONS*/}
                    <div className="w-full flex flex-col mt-5 gap-5 justify-center items-center">
                        <button
                            onClick={handleSave}
                            className="w-full inline-flex flex-col items-start gap-2.5 px-5 py-3.5 relative flex-[0_0_auto] bg-melon-yellow rounded-lg overflow-hidden"
                        >
                            <div
                                className="
                                    w-full
                                    flex items-center justify-center
                                    font-manager-acrom-button4-16-medium-acrom
                                    font-[number:var(--manager-acrom-button4-16-medium-acrom-font-weight)]
                                    text-black text-[length:var(--manager-acrom-button4-16-medium-acrom-font-size)]
                                    text-center tracking-[var(--manager-acrom-button4-16-medium-acrom-letter-spacing)]
                                    leading-[var(--manager-acrom-button4-16-medium-acrom-line-height)]
                                    [font-style:var(--manager-acrom-button4-16-medium-acrom-font-style)]
                                "
                            >
                                Добавить
                            </div>
                        </button>
                        <button
                            onClick={handleClose}
                            className="
                            w-full inline-flex flex-col
                            items-start gap-2.5 px-5 py-3.5 relative flex-[0_0_auto] bg-gray-100 rounded-lg overflow-hidden">
                            <div
                                className="
                                    w-full
                                    flex items-center justify-center
                                    font-manager-acrom-button4-16-medium-acrom
                                    font-[number:var(--manager-acrom-button4-16-medium-acrom-font-weight)]
                                    text-black text-[length:var(--manager-acrom-button4-16-medium-acrom-font-size)]
                                    text-center tracking-[var(--manager-acrom-button4-16-medium-acrom-letter-spacing)]
                                    leading-[var(--manager-acrom-button4-16-medium-acrom-line-height)]
                                    [font-style:var(--manager-acrom-button4-16-medium-acrom-font-style)]
                                "
                            >
                                Отмена
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </FlowbiteModal>
    );
};

export const AddChatParticipantModal = ({ isOpen, onClose, claim_pk, chat_pk }: AddParticipantModalProps) => {
    // Модальное окно с заполнением данных о сотруднике и добавлением
    const queryClient = useQueryClient();
    const [colleague, setColleague] = useState<ColleagueForSelector | null>(null)

    const { mutate: add } = useMutation({
        mutationFn: addParticipant,
        onSuccess: (data) => {
            queryClient.invalidateQueries({
                queryKey: ['chat', claim_pk.toString()],
                refetchType: 'all',
            });
        },
        onSettled: () => {
            // Заново обновляем состояние модели редактирования
            onClose()
        }
    });

    const handleColleagueChange = (value: ColleagueForSelector) => {
        setColleague(value)
    }

    const handleClose = () => {
        onClose()
    }

    const handleSave = () => {
        add({
            userId: colleague?.pk || '',
            chatId: chat_pk
        })
    }


    return (
        <FlowbiteModal
            show={isOpen}
            onClose={onClose}
            size={'md'}
        >
            <div className="w-full flex p-6 relative bg-white rounded-lg">
                {/*CONTAINER*/}
                <div className="w-full inline-flex flex-col justify-between items-center">
                    {/*HEADER*/}
                    <div className="
                        w-full
                        mb-4
                        inline-flex flex-row
                        justify-end
                        items-center
                        text-black text-2xl leading-[normal]
                        relative [font-family:'Acrom-Medium',Helvetica]
                        font-medium
                        tracking-[0]
                    ">
                        {/*CLOSE BUTTON*/}
                        <button
                            onClick={onClose}
                            className="flex justify-center items-center w-8 h-8 top-2.5 bg-[#f2f2f2] rounded-lg">
                            <img src={Close} className=" w-6 h-6" alt="Manager ic close" />
                        </button>
                    </div>
                    {/*BODY*/}
                    <div className="
                        w-full
                        h-full
                        flex
                        flex-col
                        items-start
                        gap-4
                    ">
                        <div
                            className="
                            relative
                            w-full
                            text-[#949494]
                            text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)]
                            leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)]
                            font-manager-acrom-ph-14-medium-acrom
                            font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)]
                            tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)]
                            [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]
                            ">
                            Пользователь
                        </div>
                        <SelectDropdown
                            fetchDataFunc={useChatAvailableParticipantsQuery}
                            renderItem={(item) => (renderCollegeName(item))}
                            onChange={handleColleagueChange}
                            selected={colleague}
                            filterParam={chat_pk}
                        />


                    </div>
                    {/*BUTTONS*/}
                    <div className="w-full flex flex-col mt-5 gap-5 justify-center items-center">
                        <button
                            disabled={!colleague}
                            onClick={handleSave}
                            className={`
                            relative
                            w-full inline-flex flex-col
                            items-start
                            gap-2.5 px-5 py-3.5
                            flex-[0_0_auto]
                            rounded-lg overflow-hidden
                            bg-[#fcd700]
                            ${!colleague ? 'bg-gray-100' : 'bg-melon-yellow'}
                            `}>
                            <div
                                className="
                                w-full
                                flex
                                text-black
                                text-center
                                items-center
                                justify-center
                                font-manager-acrom-button4-16-medium-acrom
                                font-[number:var(--manager-acrom-button4-16-medium-acrom-font-weight)]
                                text-[length:var(--manager-acrom-button4-16-medium-acrom-font-size)]
                                tracking-[var(--manager-acrom-button4-16-medium-acrom-letter-spacing)]
                                leading-[var(--manager-acrom-button4-16-medium-acrom-line-height)]
                                [font-style:var(--manager-acrom-button4-16-medium-acrom-font-style)]
                                ">
                                Добавить
                            </div>
                        </button>
                        <button
                            onClick={handleClose}
                            className="
                            w-full inline-flex flex-col
                            items-start
                            gap-2.5 px-5 py-3.5 relative
                            flex-[0_0_auto]
                            bg-gray-100
                            rounded-lg
                            overflow-hidden
                        ">
                            <div
                                className="
                                w-full
                                flex items-center justify-center
                                font-manager-acrom-button4-16-medium-acrom
                                font-[number:var(--manager-acrom-button4-16-medium-acrom-font-weight)]
                                text-black text-[length:var(--manager-acrom-button4-16-medium-acrom-font-size)]
                                text-center tracking-[var(--manager-acrom-button4-16-medium-acrom-letter-spacing)]
                                leading-[var(--manager-acrom-button4-16-medium-acrom-line-height)]
                                [font-style:var(--manager-acrom-button4-16-medium-acrom-font-style)]
                            ">
                                Отмена
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </FlowbiteModal>
    );
};

const ContextMenu = ({ item, openFilesModal, openRemoveModal }: ContextMenuProps) => {
    // Контекстное меню сотрудника в списке
    return (
        <Dropdown
            className="pr-5"
            arrowIcon={false}
            inline={true}
            label={
                // TODO в компонент
                <div
                    className="self-center flex justify-center items-center ml-auto w-4 h-10 rounded-lg overflow-hidden">
                    <img className="flex " src={DotsMenu} alt="" />
                </div>
            }
        >

            {/*LIST*/}
            <div
                className="
                p-2
                w-full
                flex flex-col
                justify-start
                items-start gap-5"
            >
                <button
                    onClick={openFilesModal}
                    className="w-full p-2 flex flex-row"
                >
                    <img src={EditIcon} alt="" />
                    Редактировать
                </button>
                <button
                    onClick={openRemoveModal}
                    className="w-full p-2 flex flex-row text-red-500"
                >
                    <img src={DeleteRedIcon} alt="" />
                    Удалить
                </button>
            </div>
        </Dropdown>
    );
};

export const ColleagueItem = ({ colleague, claim_pk }: ColleagueProps) => {
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const colleaguePopupRef = useRef<ColleagueInfoPopupHandle>(null);
    const openEditModal = () => setIsEditModalOpen(true);
    const closeEditModal = () => setIsEditModalOpen(false);

    const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);
    const openRemoveModal = () => setIsRemoveModalOpen(true);
    const closeRemoveModal = () => setIsRemoveModalOpen(false);

    const toggleDropdown = () => {
        setIsDropdownOpen(prevState => !prevState)
    }

    return (
        <div
            className="
                relative
                flex
                flex-[0_0_auto]
                flex-col
                justify-start
                gap-5 w-full
                min-h-24
                rounded-lg
                shadow-shadow-card
                mb-2
            "
        >
            {/*УСТАНОВКА МОДАЛЬНЫХ ОКОН С РЕДАКТИРОВАНИЕМ И УДАЛЕНИЕМ*/}
            <ColleagueModelProvider>
                <ColleagueEditModal
                    claim_pk={claim_pk}
                    colleague={colleague}
                    isOpen={isEditModalOpen}
                    onClose={closeEditModal}
                />
            </ColleagueModelProvider>
            <RemoveModal
                claim_pk={claim_pk}
                colleague={colleague}
                isOpen={isRemoveModalOpen}
                onClose={closeRemoveModal}
            />
            {/*СОТРУДНИК*/}
            <div className="
                flex
                flex-[0_0_auto]
                w-full
                flex-row
                justify-between
                items-center
                gap-3
                bg-white
                shadow-shadow-card
                rounded-lg
                p-4
                "
            >
                <ColleagueInfoPopup ref={colleaguePopupRef} />
                <div
                    className="flex flex-row justify-between items-center gap-2 cursor-pointer"
                    onClick={(e) =>
                        colleaguePopupRef.current?.openAtElement(e.currentTarget, colleague.colleague_pk)}
                >
                    {/*AVATAR*/}
                    <img
                        className="relative w-16 h-16 rounded-[50%]"
                        src={colleague.colleague_pk?.photo_img?.file ?? Temp}
                        alt=""
                    />
                    <div className="flex flex-col w-56 items-start gap-0.5 relative">
                        <div
                            className="w-full text-black text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] relative font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                            {colleague.type === 'OUTSTAFF' ? shortenText(colleague.full_name, 48) : shortenText(`${colleague.colleague_pk?.last_name} ${colleague.colleague_pk?.first_name} ${colleague.colleague_pk?.middle_name}`, 48)}
                        </div>
                        {colleague.type !== 'OUTSTAFF' && <div
                            className="w-full text-[#949494] text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)] leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)] relative font-manager-acrom-ph-14-medium-acrom font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]">
                            {shortenText(formatColleaguePostBrand(colleague), 46)}
                        </div>}
                    </div>
                </div>

                {/*BUTTONS*/}
                <div className="flex flex-row justify-end">
                    {/*DROPDOWN BUTTON*/}
                    <button
                        onClick={toggleDropdown}
                        className='
                        flex
                        justify-center
                        items-center
                        p-2
                        w-12!
                        h-12!
                        flex-[0_0_auto]
                        bg-melon-light
                        rounded-md'
                    >
                        <img src={isDropdownOpen ? ArrowUp : ArrowDown} alt="" />
                    </button>
                    {/*MENU DOTS*/}
                    <div className="ml-5 flex h-8! w-4! flex-row justify-end items-center">
                        <ContextMenu openRemoveModal={openRemoveModal} openFilesModal={openEditModal} item={'test'} />
                    </div>
                </div>
            </div>
            {/*ФАЙЛЫ*/}
            {isDropdownOpen &&
                <div
                    className="
                    flex flex-col
                    w-full
                "
                >
                    {/*ФАЙЛ БИЛЕТОВ*/}
                    <div
                        className="
                            flex
                            flex-col
                            flex-[0_0_auto]
                            items-start
                            gap-3
                            mx-4
                            py-4
                            border-b-[1px]
                            border-b-gray-200"
                    >
                        <div className="text-melon-grey">Билет</div>
                        <AttachmentsList
                            file_objs={colleague.files.filter(e => e.group === 'TICKETS' && !e.deleted_at)}
                            needed={colleague.tickets_need}
                            group={'TICKETS'}
                        />
                    </div>
                    {/*ФАЙЛ ОТЕЛЕЙ*/}
                    <div
                        className="
                            flex
                            flex-col
                            flex-[0_0_auto]
                            items-start
                            gap-3
                            mx-4
                            py-4
                            border-b-[1px]
                            border-b-gray-200"
                    >
                        <div className="text-melon-grey">Отель</div>
                        <AttachmentsList
                            file_objs={colleague.files.filter(e => e.group === 'HOTEL' && !e.deleted_at)}
                            needed={colleague.hotel_need}
                            group={'HOTEL'}
                        />
                    </div>
                    {/*ФАЙЛ ДРУГИХ ДОКУМЕНТОВ*/}
                    <div className="
                            flex
                            flex-col
                            flex-[0_0_auto]
                            items-start
                            gap-3
                            mx-4
                            py-4
                            border-b-[1px]
                            border-b-gray-200"
                    >
                        <div className="text-melon-grey">Другие документы</div>
                        <AttachmentsList
                            file_objs={colleague.files.filter(e => e.group === 'OTHER_DOCUMENTS' && !e.deleted_at)}
                            needed={colleague.other_documents_need}
                            group={'OTHER_DOCUMENTS'}
                        />
                    </div>
                </div>}
        </div>
    );


}

export const ColleaguesTable = ({ colleagues, outstaff, tab, claim_pk }: ColleaguesAndOutstaffTable) => {
    return (
        <div className="h-full w-full flex flex-col justify-start items-start">
            {tab === 'colleagues' && colleagues.map((item, index) => (
                <ColleagueItem key={index} claim_pk={claim_pk} colleague={item} />))}

            {tab === 'outstaff' && outstaff.map((item, index) => (
                <ColleagueItem key={index} claim_pk={claim_pk} colleague={item} />))}
        </div>
    );
}

export const Colleagues = ({ colleagues, outstaff, claim_pk }: ColleaguesAndOutstaff) => {
    const [activeTab, setActiveTab] = useState<string>('colleagues')
    return (
        <div className="flex flex-col gap-5 m-5 ">
            <ColleaguesTabs
                tab={activeTab}
                claim_pk={claim_pk}
                setActive={setActiveTab}
                colleagues={colleagues}
                outstaff={outstaff} />
            <ColleaguesTable
                tab={activeTab}
                claim_pk={claim_pk}
                colleagues={colleagues}
                outstaff={outstaff} />
        </div>
    );
}

interface ColleagueEditProps {
    required: boolean
    error: string | null
    name?: string | null
    phone?: string | null
    onChange: (value: string) => void
}

export const NameEdit = ({ name, onChange, required, error }: ColleagueEditProps) => {
    const [text, setComment] = useState<string | null>(name || null);

    const max = 100;
    const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        if (e.target.value.length <= max) {
            setComment(e.target.value);
            onChange(e.target.value)
        }
    };
    return (
        <div className="w-full inline-flex flex-col mb-5 items-start gap-2 relative flex-[0_0_auto]">
            <div
                className="w-full flex flex-row text-[#949494] text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)] leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)] relative font-manager-acrom-ph-14-medium-acrom font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]">
                Имя {required && <div className="text-red-500">*</div>}
            </div>

            <div className="text-red-500 text-sm">{error}</div>
            <div
                className="flex w-full items-start gap-2.5 px-4 py-3.5 flex-[0_0_auto] bg-[#f2f2f2] rounded-lg overflow-hidden">
                <TextareaCount
                    text={text || ''}
                    rows={4}
                    max={max}
                    handleChange={handleChange} placeholder={''} />
            </div>
        </div>
    );
}

interface ColleagueSearchProps {
    required: boolean
    error: string | null
    colleague_pk: ColleagueForSelector | null
    onChange: (value: ColleagueForSelector) => void
}

const renderCollegeName = (item: any) => {
    let val = item.name || '';
    if (item.post && item.post.length > 0) {
        val += `, ${item.post}`;
    }
    if (item.brand && item.brand.length > 0) {
        val += `, ${item.brand}`;
    }
    return val;
}

export const ColleagueSearch = ({ colleague_pk, onChange, required, error }: ColleagueSearchProps) => {
    return (
        <div className="w-full mb-5 inline-flex flex-col items-start gap-2 relative flex-[0_0_auto]">
            <div
                className="w-full flex flex-row text-[#949494] text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)] leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)] relative font-manager-acrom-ph-14-medium-acrom font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)] tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)] [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]">
                Пользователь {required && <div className="text-red-500">*</div>}
            </div>

            <div className="text-red-500 text-sm">{error}</div>
            <SelectDropdown
                fetchDataFunc={useColleaguesQuery}
                renderItem={(item) => (renderCollegeName(item))}
                onChange={onChange}
                selected={colleague_pk}
            />
        </div>
    );
}